const BASE_URL = "erp-recruitment";

export const getCVCampaignUrl = (screenCode: string) => {
  return `${BASE_URL}/cv/process/${screenCode}`;
};

export const getManagerByLevelUrl = (screenCode: string) => {
  return `${BASE_URL}/cv/process/${screenCode}/program/manager`;
};

export const forwardEvaluationUrl = (
  screenCode: string,
  programCode: string
) => {
  return `${BASE_URL}/cv/process/${screenCode}/${programCode}/authority`;
};

export const getCVOfCampaignUrl = (screenCode: string) => {
  return `${BASE_URL}/cv/process/${screenCode}/cv/review`;
};

export const getDetailCampaignUrl = (
  screenCode: string,
  programCode: string
) => {
  return `${BASE_URL}/program/${screenCode}/${programCode}/detail`;
};

export const getInfoSelectedCandidateUrl = (
  screenCode: string,
  applyInfoId: string
) => {
  return `${BASE_URL}/candidate/${screenCode}/${applyInfoId}`;
};

export const evaluateCVUrl = (screenCode: string, itemCode: string) => {
  return `${BASE_URL}/cv/process/${screenCode}/${itemCode}/review`;
};

export const evaluateCampaignUrl = (
  screenCode: string,
  itemCode: string,
  reviewCvId
) => {
  return `${BASE_URL}/cv/process/${screenCode}/${itemCode}/review/${reviewCvId}/confirm`;
};

export const getDetailEvaluationUrl = (screenCode: string, reviewCvId) => {
  return `${BASE_URL}/cv/process/${screenCode}/${reviewCvId}`;
};
